import { Divider, Stack, useTheme } from '@mui/material';
import { DownloadDocument, StyledCard, TagChip } from 'presentation/components';
import Icon from 'presentation/icons';
import React from 'react';
import { translations } from 'presentation/translations-new';
import { ConsultPreviewRefundEnum } from 'domain/usecases';
import { OperationStateTypesEnum } from 'presentation/constants';
import {
	ChipContainer,
	PreviewItems,
	StyledListItemIcon,
	StyledListItemText,
	StyledStackItems,
} from './styles';
import { cardStyleByStatusPreview } from '../../constants/cardByStatus';
import { useGetRequestPreviewProtocolPdf } from '../../hooks';
import { formatRefundDate } from '../../utils';
import { RequestErrorModal } from '../RequestErrorModal';
import { PreviewCardProps } from './types';
import { PreviewCardTitle } from '../PreviewCardTitle';

const { previewWorksheet, serviceProtocol } = translations['pt-br'].privateFlow.consultPreviewRefund;

const { requestedAt } = translations['pt-br'].commons;

export const PreviewCardNew = ({ data }: PreviewCardProps) => {
	const theme = useTheme();
	const { downloadPdf, DOWNLOAD_PDF_IS_LOADING, DOWNLOAD_PDF_IS_ERROR, setOperationState } =
		useGetRequestPreviewProtocolPdf();
	const { protocol, ansProtocol, requestDetails, startDate, protocolSituationCode } = data;
	const startDateFormatted = formatRefundDate(startDate);

	const { footer, headerIcon, borderColor, iconColor } = cardStyleByStatusPreview(
		theme,
		protocolSituationCode,
	);

	const { request } = requestDetails[0];

	const showDownloadPreview = [
		ConsultPreviewRefundEnum.APPROVED,
		ConsultPreviewRefundEnum.DENIED,
	].includes(protocolSituationCode);

	async function handleDownloadPDF() {
		downloadPdf({ protocol, request });
	}

	return (
		<StyledCard.Container
			$borderTop
			$borderColor={borderColor}
			sx={{ height: '100%', justifyContent: 'flex-start' }}>
			<StyledCard.Header
				title={<PreviewCardTitle highlightedText={request} />}
				customIcon={<Icon name={headerIcon.customIconName} color={iconColor} />}
				titleColor={theme.palette.primary.dark}
			/>

			<Divider />

			<StyledStackItems>
				<PreviewItems disablePadding>
					<StyledListItemIcon>
						<Icon color={theme.brand.primary.blue} name="event-filled" />
					</StyledListItemIcon>
					<StyledListItemText primary={requestedAt} secondary={startDateFormatted} />
				</PreviewItems>
				<PreviewItems disablePadding>
					<StyledListItemIcon>
						<Icon name="content-paste-filled" size={20} />
					</StyledListItemIcon>
					<StyledListItemText primary={serviceProtocol} secondary={ansProtocol} />
				</PreviewItems>
			</StyledStackItems>

			{showDownloadPreview ? (
				<Stack>
					<DownloadDocument
						label={previewWorksheet}
						handleAction={handleDownloadPDF}
						isLoading={DOWNLOAD_PDF_IS_LOADING}
					/>
				</Stack>
			) : null}

			<ChipContainer>
				<TagChip label={footer.chipText} color={footer.chipVariant} />
			</ChipContainer>

			<RequestErrorModal
				open={DOWNLOAD_PDF_IS_ERROR}
				setOpen={() => setOperationState(OperationStateTypesEnum.NONE)}
			/>
		</StyledCard.Container>
	);
};
